import React from 'react'
import List, { BulletType } from '@dustin-web/microsite-components/src/list'
import { GridBlock } from '../../graphql/generated/graphql-types'

type Props = {
  bulletType: BulletType
  list: GridBlock[]
}

export const ListBLock = ({ bulletType, list }: Props) => {
  const items = list.map(item => {
    return {
      title: item.properties.href.text,
      href: item.properties.href.url,
    }
  })
  return <List bulletType={bulletType} items={items} />
}
